module.exports = __webpack_public_path__ + "static/img/nivel apl.92fd6bfa.png";